/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 11/9/2021
 * @Example
 */

import React, { useRef, useState, useEffect } from 'react';
import { Button, Dropdown, DateRangePicker, ButtonIcon, Popover, Avatar, Tooltip } from 'diginet-core-ui/components';
import Filter from "../../../filter/filter";
import Config from "../../../../config/index";
import ActionToolbar from "../../../common/toolbar/action-toolbar";
import { useDispatch } from 'react-redux';
import * as generalActions from '../../../../redux/general/general_actions';
import _ from 'lodash';
import moment from 'moment';
import { Column } from "devextreme-react/data-grid";
import GridContainer from "../../../grid-container/grid-container";
import { makeStyles } from '@material-ui/core/styles';
import Status from "../../../common/status/status";
import { CalendarNew } from 'diginet-core-ui/icons';
import W84F3005 from '../../../W8X/W84/W84F3005/W84F3005';
import W09F2282Popover from './W09F2282Popover';
import * as W09F2282Actions from '../../../../redux/W0X/W09F2282/W09F2282_actions';
import * as approvalActions from '../../../../redux/approvals/approvals_actions';
import { LoadPanel } from "devextreme-react";
import W09F2281 from '../W09F2281/W09F2281';

const useStyles = makeStyles(theme => ({
    divApproval: {
        backgroundColor: '#cfcfcf',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 20px',
        borderRadius: 10,
        width: 'max-content'
    },
    VoucherNo: {
        maxWidth: 500,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        textAlign: 'left'
    }
}))

const W09F2282 = (props) => {
    const { location } = props;
    const dispatch = useDispatch();
    const classes = useStyles();
    const FormID = "W09F2282";
    const Language = Config.language || "84";

    const filterCboEmployees = useRef({
        Type: "EmployeeID",
        timer: null,
        HostID: "",
        strSearch: "",
        skip: 0,
        limit: 50
    });

    const [filterSearch, setFilterSearch] = useState({
        ApprovalStatus: null,
        EmployeeID: "",
        DateFrom: moment().startOf('year').format("YYYY-MM-DD"),
        DateTo: moment().endOf('year').format("YYYY-MM-DD")
    });

    const [iPermission, setIPermission] = useState(0);
    const [dataCboEmployees, setDataCboEmployees] = useState({ rows: [], total: 0 });
    const [cbAppStatus, setCbAppStatus] = useState([]);
    const [dataGrid, setDataGrid] = useState({ rows: [], total: 0 });
    const filterGrid = useRef({ limit: 10, skip: 0 });
    const [loading, setLoading] = useState(false);

    const item = useRef(null);
    const [showW84F3005Popup, setShowW84F3005Popup] = useState(false);
    const [showW09F2281Popup, setShowW09F2281Popup] = useState(false);
    const [type, setType] = useState(null);
    const popover = useRef(null);

    useEffect(() => {
        if (!iPermission) {
            loadPermission();
            return;
        }
        getCboAppStatus();
        getDataGrid();
        /* eslint-disable */
    }, [iPermission])

    useEffect(() => {
        if (location && location.state?.voucher_id) {
            item.current = { VoucherID: location.state.voucher_id };
            setShowW09F2281Popup(true);
        }
        /* eslint-disable */
    }, [location])

    const loadPermission = () => {
        dispatch(generalActions.getPermission("W09F2282", (isPer) => {
            setIPermission(isPer);
        }));
    };

    const onLoadDataFilter = () => {
        loadCboEmployees();
    }

    const getCboAppStatus = () => {
        dispatch(approvalActions.getCboStatus({ FormID: 'STANDARD', Language }, (error, data) => {
            if (error) {
                Config.popup.show("ERROR", error || Config.lang("Loi_chua_xac_dinh"));
                return false;
            }
            setCbAppStatus(data);
        }));
    }

    const loadCboEmployees = (isReset) => {
        const { HostID, Type, skip, limit, strSearch: search } = filterCboEmployees.current;
        const param = { HostID, Type, FormID, Language, skip, limit, search };
        dispatch(generalActions.getCboEmployees(param, (error, data) => {
            if (error) {
                Config.popup.show("ERROR", error || Config.lang("Loi_chua_xac_dinh"));
                return false;
            }
            const rows = data?.rows ? data.rows : data;
            setDataCboEmployees({
                rows: isReset ? rows : dataCboEmployees.rows.concat(rows),
                total: data.total
            })
        }));
    };

    const filterChange = (key, e) => {
        if (!e) return;
        let value = _.get(e, "value", _.get(e, "target.value", ""));
        switch (key) {
            case "ApprovalStatus":
            case "EmployeeID":
                setFilterSearch({ ...filterSearch, [key]: value });
                break;
            case "RangePicker":
                const DateFrom = _.isArray(value) ? value[0] : value;
                const DateTo = _.isArray(value) ? value[1] : value;
                setFilterSearch({ ...filterSearch, DateFrom, DateTo });
                break;
            default:
                break;
        }
    }

    const renderFilterData = () => {
        return (
            <Filter
                isUseDDCore={true}
                openOnFieldClick={true}
                placeholder={Config.lang("Noi_dung_can_tim_kiem")}
                onOpenLoaded={onLoadDataFilter}
                renderFilter={() => {
                    return (
                        <div>
                            <Dropdown
                                clearAble
                                style={{ marginBottom: 10 }}
                                dataSource={cbAppStatus}
                                value={filterSearch.ApprovalStatus}
                                viewType={"outlined"}
                                valueExpr={"ApprovalStatus"}
                                label={Config.lang("Trang_thai_duyet")}
                                placeholder={Config.lang("Chon")}
                                displayExpr={"AppStatusName"}
                                onChange={(e) => filterChange("ApprovalStatus", e)}

                            />
                            <Dropdown
                                clearAble
                                style={{ marginBottom: 10 }}
                                dataSource={_.get(dataCboEmployees, "rows", [])}
                                total={_.get(dataCboEmployees, "total", 0)}
                                skip={filterCboEmployees.current.skip}
                                limit={filterCboEmployees.current.limit}
                                value={filterSearch.EmployeeID}
                                viewType={"outlined"}
                                valueExpr={"EmployeeID"}
                                keyExpr={"EmployeeName"}
                                searchDelayTime={1000}
                                label={Config.lang("Nhan_vien")}
                                placeholder={Config.lang("Chon")}
                                displayExpr={"{EmployeeID} - {EmployeeName}"}
                                onChange={(e) => filterChange("EmployeeID", e)}
                                onInput={(e) => {
                                    filterCboEmployees.current.strSearch = e.target.value;
                                    filterCboEmployees.current.skip = 0;
                                    loadCboEmployees(true);
                                }}
                                onLoadMore={(e) => {
                                    filterCboEmployees.current.skip = e.skip;
                                    filterCboEmployees.current.limit = e.limit;
                                    loadCboEmployees();
                                }}
                            />
                            <DateRangePicker
                                clearAble
                                controls
                                value={[filterSearch.DateFrom, filterSearch.DateTo]}
                                style={{ marginBottom: 0 }}
                                viewType={"outlined"}
                                label={Config.lang("Ngay_tao")}
                                onChange={e => filterChange("RangePicker", e)}
                                placeholder={"DD/MM/YY - DD/MM/YY"}
                                returnFormat={"YYYY-MM-DD"}
                            />
                            <div style={{ display: "flex", justifyContent: "center", paddingTop: 10 }}>
                                <Button
                                    size={"medium"}
                                    color={"primary"}
                                    viewType={"outlined"}
                                    label={Config.lang("Tim_kiem")}
                                    startIcon={"Search"}
                                    onClick={() => getDataGrid(true)}
                                />
                            </div>
                        </div>
                    );
                }}
            />
        );
    };

    const getDataGrid = (isReset) => {
        if (isReset) {
            filterGrid.current = { limit: 10, skip: 0 };
        }
        const params = {
            DivisionID: Config.getDivisionID(),
            FormID, Language,
            ...filterGrid.current,
            ...filterSearch
        };
        setLoading(true);
        dispatch(W09F2282Actions.getForm(params, (error, data) => {
            if (error) {
                Config.popup.show("ERROR", error || Config.lang("Loi_chua_xac_dinh"));
                setLoading(false);
                return false;
            }
            setLoading(false);
            setDataGrid({
                rows: data?.rows ?? [],
                total: data?.total ?? 0
            });
        }));
    }

    const onChangePage = (page) => {
        filterGrid.current.skip = page * filterGrid.current.limit;
        getDataGrid();
    }

    const onChangePerPage = (perPage) => {
        filterGrid.current.skip = 0;
        filterGrid.current.limit = perPage;
        getDataGrid();
    }

    const renderEmpProfile = (e) => {
        const { data } = e.row;
        const user = Config.getUser({ UserID: data.CreateUserID });
        const { EmployeeID = '', EmployeeName = '', DepartmentName = '', DateJoined, UserPictureURL } = user;
        const _DateJoined = DateJoined ? moment(DateJoined).format('DD-MM-YYYY') : '';
        const CreateDate = data?.CreateDate.replace('T', ' ').replace('Z', '');
        return (
            <div className={"display_row align-center pdt10 pdb10"}>
                <Avatar data={{ EmployeeID, EmployeeName, DepartmentName, DateJoined: _DateJoined }} hoverAble readOnly
                    src={UserPictureURL?.indexOf('http') < 0
                        ? Config.getCDNPath() + UserPictureURL
                        : UserPictureURL
                    } width={46} height={46} />
                <div className="pdl10">
                    <div className={classes.divText}>
                        {EmployeeName}
                    </div>
                    {CreateDate &&
                        <div className={"display_row align-center"}>
                            <CalendarNew width={14} />
                            <span className="mgl5" style={{ fontWeight: 200 }}>{moment(CreateDate).format("DD/MM/YYYY HH:mm A")}</span>
                        </div>
                    }
                </div>
            </div>
        );
    };

    const renderVoucherNo = (e) => {
        const { data } = e.row;
        const content = <div className={classes.VoucherNo} dangerouslySetInnerHTML={{ __html: data.VoucherNo }} ></div>;
        return <Tooltip title={content}>{content}</Tooltip>;
    }

    const renderAppStatus = (e) => {
        const { data } = e.row;
        const status = cbAppStatus.find(rs => Number(rs.ApprovalStatus) === data.ApprovalStatus);
        return status && <Status data={status} keyExpr="ApprovalStatus" />;
    }

    const onAction = (mode, data, el) => {
        switch (mode) {
            case 'view':
                item.current = data;
                setShowW09F2281Popup(true);
                break;
            case 'history':
                item.current = data;
                setShowW84F3005Popup(true);
                break;
            case 'approve':
            case 'reject':
                if (popover.current) {
                    item.current = data;
                    setType(mode)
                    popover.current.setPosition(el.currentTarget);
                    popover.current.show();
                }
                break;
            case 'cancel':
                onCancel(data);
                break;
            default:
                break;
        }

    }

    const renderAction = (e) => {
        const { ApprovalStatus } = e.data;
        return (
            <div className={"display_row align-center"}>
                <Tooltip title={Config.lang('Lich_su_duyet')}>
                    <ButtonIcon
                        onClick={() => onAction('history', e.data)}
                        size='small'
                        disabled={!(iPermission > 0)}
                        name="History"
                        viewType="text"
                        viewBox
                        circular
                    />
                </Tooltip>
                {ApprovalStatus === 0 && <>
                    <Tooltip title={Config.lang('Duyet')}>
                        <ButtonIcon
                            onClick={(el) => onAction('approve', e.data, el)}
                            size='small'
                            disabled={iPermission < 3}
                            name="Approval"
                            viewType="text"
                            viewBox
                            circular
                        />
                    </Tooltip>
                    <Tooltip title={Config.lang('Tu_choi')}>
                        <ButtonIcon
                            onClick={(el) => onAction('reject', e.data, el)}
                            size='small'
                            disabled={iPermission < 3}
                            name="Cancel"
                            viewType="text"
                            viewBox
                            circular
                        />
                    </Tooltip>
                </>
                }
                {(ApprovalStatus === 1 || ApprovalStatus === 100 || ApprovalStatus === 4) &&
                    <Tooltip title={Config.lang('Bo_duyet')}>
                        <ButtonIcon
                            onClick={(el) => onAction('cancel', e.data, el)}
                            size='small'
                            disabled={iPermission < 3}
                            name="Deny"
                            viewType="text"
                            viewBox
                            circular
                        />
                    </Tooltip>
                }
            </div>
        )
    }

    const onCancel = (data) => {
        if (!data || !data.VoucherID) {
            Config.popup.show('INFO', Config.lang("Khong_the_duyet"));
            return false;
        }
        Config.popup.show('YES_NO', Config.lang("Ban_co_chac_muon_bo_trang_thai_nay?"), () => {
            const user = Config.getUser({ UserID: data?.CreateUserID });
            const params = {
                DivisionID: Config.getDivisionID(),
                FormID: FormID,
                VoucherID: data?.VoucherID ?? "",
                EmployeeID: user?.EmployeeID ?? "",
                ApprovalLevel: data?.ApprovalLevel ?? "",
                ApprovalFlowID: data?.ApprovalFlowID ?? "",
                ApprovalStatus: data?.ApprovalStatus ?? "",
                AttendanceDate: data?.AttendanceDate ?? "",
            };
            setLoading(true);
            dispatch(approvalActions.cancelApprovals(params, (error, data) => {
                if (error) {
                    setLoading(false);
                    let message = Config.lang("Loi_chua_xac_dinh");
                    Config.popup.show('INFO', message);
                    return false;
                }
                if (data.Status === 1) {
                    setLoading(false);
                    let message = data.Message || Config.lang("Cap_tiep_theo_da_duyet._Ban_khong_the_bo_duyet");
                    Config.popup.show('INFO', message);
                    return false;
                }
                setLoading(false);
                getDataGrid();
                Config.notify.show('success', Config.lang("Thuc_hien_thanh_cong"), 2000);
            }));
        });
    }

    const onSave = (params) => {
        setLoading(true);
        popover.current.close();
        dispatch(approvalActions.saveApprovals(params, (error, data) => {
            if (error) {
                setLoading(false);
                let message = Config.lang("Loi_chua_xac_dinh");
                if (error.code === 'F1002E007') {
                    message = params.ApprovalStatus === 1 ? Config.lang("Duyet_khong_thanh_cong") : Config.lang("Tu_choi_khong_thanh_cong");
                }
                Config.popup.show('INFO', message);
                return false;
            }
            if (data.Status === 1) {
                setLoading(false);
                let message = data.Message || (params.ApprovalStatus === 1 ? Config.lang("Duyet_khong_thanh_cong") : Config.lang("Tu_choi_khong_thanh_cong"));
                Config.popup.show('INFO', message);
                return false;
            }
            setLoading(false);
            getDataGrid();
            Config.notify.show('success', Config.lang("Thuc_hien_thanh_cong"), 2000);
        }));
    }

    if (!iPermission) return null;
    return (
        <div>
            {showW09F2281Popup &&
                <W09F2281 open={showW09F2281Popup}
                          mode={'view'}
                          iPermission={iPermission}
                          FormID={'W09F2282'}
                          data={item.current}
                          onClose={() => setShowW09F2281Popup(false)}
                />
            }
            {showW84F3005Popup &&
                <W84F3005 open={showW84F3005Popup} onClose={e => setShowW84F3005Popup(false)} FormID="W09F2282"
                    TransID={item.current?.VoucherID} />
            }
            <Popover
                ref={ref => popover.current = ref}
                width={window.innerWidth < 576 ? '100%' : 590}
                height={200}
                arrow
            >
                <W09F2282Popover type={type} item={item.current} onSave={onSave} />
            </Popover>
            <LoadPanel
                shadingColor={'rgba(0,0,0,0.4)'}
                position={{ my: 'center', of: '#root' }}
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
            />
            <div className={"hidden"}>{renderFilterData()}</div>
            <ActionToolbar title={Config.lang("Duyet_khen_thuong_hang_loat")}></ActionToolbar>
            <GridContainer
                itemPerPage={filterGrid.current.limit}
                skipPerPage={filterGrid.current.skip}
                totalItems={_.get(dataGrid, "total", 0)}
                dataSource={_.get(dataGrid, "rows", [])}
                typePaging={"remote"}
                showRowLines={true}
                showBorders={false}
                showColumnLines={false}
                showColumnHeaders={false}
                hoverStateEnabled={true}
                noDataText={Config.lang("No_data")}
                height={Config.getHeightGrid() - 30}
                style={{ border: 'none' }}
                editing={{ texts: { confirmDeleteMessage: "" } }}
                onDbCellClick={(e) => onAction("view", e.data)}
                onChangePage={onChangePage}
                onChangePerPage={onChangePerPage}
            >
                <Column cellRender={renderEmpProfile} width={250} />
                <Column dataField="VoucherNo" cellRender={renderVoucherNo} />
                <Column dataField="ApprovalStatus" cellRender={renderAppStatus} minWidth={150} />
                <Column cellRender={renderAction} width={200} />
            </GridContainer>
        </div>
    );
}

export default W09F2282;
